import type { VideoTable } from "../metadata/types";

export type VideoUploadSavedByFilterOption = {
	value: string;
	label: string;
};

function collectSavedByValuesFromVideos(videos: VideoTable[]): string[] {
	const savedByValues = new Set<string>();

	for (const video of videos) {
		const metadataAddedBy = video.metadataAddedBy?.trim();
		if (metadataAddedBy === undefined || metadataAddedBy === "") {
			continue;
		}

		savedByValues.add(metadataAddedBy);
	}

	return [...savedByValues];
}

function collectSavedByValuesFromSelectedValues(selectedSavedBy: unknown): string[] {
	if (Array.isArray(selectedSavedBy) === false) {
		return [];
	}

	const savedByValues: string[] = [];

	for (const selectedValue of selectedSavedBy) {
		if (typeof selectedValue !== "string") {
			continue;
		}

		const trimmedValue = selectedValue.trim();
		if (trimmedValue === "") {
			continue;
		}

		savedByValues.push(trimmedValue);
	}

	return savedByValues;
}

export function getVideoUploadSavedByFilterOptions(
	videos: VideoTable[],
	selectedSavedBy?: unknown,
): VideoUploadSavedByFilterOption[] {
	const savedByValues = new Set<string>([
		...collectSavedByValuesFromSelectedValues(selectedSavedBy),
		...collectSavedByValuesFromVideos(videos),
	]);

	return [...savedByValues]
		.sort((leftValue, rightValue) => leftValue.localeCompare(rightValue))
		.map((savedBy) => ({
			value: savedBy,
			label: savedBy,
		}));
}
